import { Component, OnInit, Input, Optional, Self, ElementRef } from '@angular/core';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';
import { ControlValueAccessor, UntypedFormGroup, NgControl, UntypedFormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { FocusMonitor } from '@angular/cdk/a11y';

@Component({
  selector: 'number-list',
  templateUrl: './number-list.component.html',
  styleUrls: ['./number-list.component.css'],
  providers: [

    { provide: MatFormFieldControl, useExisting: NumberListComponent },

  ],
  host: {
    '[class.floating]': 'shouldLabelFloat',
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
  }
})
export class NumberListComponent implements MatFormFieldControl<number[]>, ControlValueAccessor {


  @Input() isTextArea: boolean = true;

  static nextId = 0;
  parts: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  //ngControl = null;
  errorState = false;
  controlType = 'number-list';
  id = `number-list-${NumberListComponent.nextId++}`;
  describedBy = '';


  private onChange: (value: number[]) => void;

  public changeData() {

    this.onChange(this.value);
  }

  writeValue(obj: number[]): void {
    this.value = obj;
  }
  registerOnChange(onChange: (value: number[]) => void): void {
    this.onChange = onChange;
  }
  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if (isDisabled) {
      this.parts.get("textValue").disable();
    }
    else {
      this.parts.get("textValue").enable();
    }
  }


  get empty() {
    const { value: { textValue } } = this.parts;

    // console.log("empty:" + dateText + !dateText);
    return !textValue;
  }

  get shouldLabelFloat() { return this.focused || !this.empty; }

  @Input()
  get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean { return this._required; }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _disabled = false;

  @Input()
  get value(): number[] | null {

    const { value: { textValue } } = this.parts

    let texts = textValue.split(" ");

    let numbers: Array<number> = new Array();

    texts.forEach(x => {
      
      x = x.trim();

      if (x != null && x!='' && parseInt(x)!=null) {

        console.log("parseInt(x)");

        console.log(parseInt(x));

        numbers.push(parseInt(x));

      }

    });

    console.log("numbers");
    console.log(numbers);

    return numbers;

  }

  set value(value: number[] | null) {

    let text: string = '';
    if (value != null) {
      value.forEach(x => {
        if (x != null) {
          text += x.toString() + ' ';
        }
      });


      this.parts.get("textValue").setValue(text.trim());

    }
    this.stateChanges.next();
  }

  constructor(@Optional() @Self() public ngControl: NgControl, fb: UntypedFormBuilder, private fm: FocusMonitor, private elRef: ElementRef<HTMLElement>) {

    // Setting the value accessor directly (instead of using
    // the providers) to avoid running into a circular import.
    if (this.ngControl != null) { this.ngControl.valueAccessor = this; }

    this.parts = fb.group({
      textValue: ''
    });

    fm.monitor(elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {

    if (this.isTextArea) {
      if ((event.target as Element).tagName.toLowerCase() != 'textarea') {
        this.elRef.nativeElement.querySelector('textarea')!.focus();
      }
      else {
        if ((event.target as Element).tagName.toLowerCase() != 'input') {
          this.elRef.nativeElement.querySelector('input')!.focus();
        }
      }
    }
  }
}
